import React from 'react';
import { psychologistInfo } from '../mock/mockData';
import { Mail, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-rose-950 to-rose-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Section */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-rose-100">
              {psychologistInfo.name}
            </h3>
            <p className="text-rose-200 mb-4">
              {psychologistInfo.title}
            </p>
            <p className="text-rose-300 text-sm leading-relaxed">
              Acompanhamento psicológico especializado para jovens adultos e adultos.
              Um espaço seguro para o seu bem-estar.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-rose-100">Links Rápidos</h4>
            <nav className="space-y-2">
              {[
                { label: 'Início', id: 'hero' },
                { label: 'Sobre Mim', id: 'about' },
                { label: 'Serviços', id: 'services' },
                { label: 'Como Funciona', id: 'how-it-works' },
                { label: 'FAQ', id: 'faq' },
                { label: 'Contacto', id: 'contact' }
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-rose-300 hover:text-rose-100 transition-colors text-sm"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-rose-100">Contacto</h4>
            <div className="space-y-3">
              <a
                href={`mailto:${psychologistInfo.email}`}
                className="flex items-center gap-3 text-rose-300 hover:text-rose-100 transition-colors group"
              >
                <Mail className="h-5 w-5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span className="text-sm break-all">{psychologistInfo.email}</span>
              </a>
              <a
                href={`https://instagram.com/${psychologistInfo.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-rose-300 hover:text-rose-100 transition-colors group"
              >
                <Instagram className="h-5 w-5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span className="text-sm">@{psychologistInfo.instagram}</span>
              </a>
              <div className="pt-4">
                <p className="text-rose-200 text-sm">
                  {psychologistInfo.consultationType}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-rose-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-rose-300 text-sm">
              © {currentYear} {psychologistInfo.name}. Todos os direitos reservados.
            </p>
            <p className="flex items-center gap-2 text-rose-300 text-sm">
              Feito com <Heart className="h-4 w-4 fill-rose-400 text-rose-400" /> para o seu bem-estar
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
